import React from 'react'
import { FileCopy } from '@material-ui/icons'
import { Button, Typography } from 'procyon-ui'
import { enqueueNotification } from 'Utils/Helpers'

const CredentialsHelp = ({ privateKey, onClose }) => {
  const command = `cat encrData.txt | base64 -d | openssl aes-256-cbc -d -pbkdf2 | base64 -d > key.json`

  const copyCommand = () => {
    try {
      navigator.clipboard.writeText(command)
      enqueueNotification('Command copied to your clipboard!', 'info')
    } catch (error) {
      console.error(error)
    }
  }

  const onDownload = () => {
    if (!privateKey) return enqueueNotification('Something went wrong!', 'error')
    var element = document.createElement('a')
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(privateKey))
    element.setAttribute('download', 'encrData')

    element.style.display = 'none'
    document.body.appendChild(element)

    element.click()

    document.body.removeChild(element)
  }

  return (
    <div>
      {/* Alert Banner */}
      <div className='mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md'>
        <Typography variant='body-regular' className='text-blue-800'>
          Run this command to generate the key JSON file from PrivateKeyData
        </Typography>
      </div>

      <hr className='my-4 border-gray-200' />

      {/* Command Display Box */}
      <div className='mt-4 flex justify-between items-center p-3 border border-gray-300 rounded-lg bg-gray-50'>
        <span className='font-mono text-sm text-gray-700 break-all mr-4'>{command}</span>

        <button
          onClick={copyCommand}
          className='flex items-center justify-center p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-all focus:outline-none'
          title='Copy Command'
        >
          <FileCopy fontSize='small' />
        </button>
      </div>

      {/* Download Action */}
      <div className='flex justify-center mt-8'>
        <Button onClick={onDownload} variant='primary'>
          Download Private Key Data
        </Button>
      </div>

      <div className='flex flex-row-reverse'>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  )
}

export default CredentialsHelp
